(() => {
  class VeloraMiniCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-vmpc-viewport]');
      this.prev = root.querySelector('[data-vmpc-prev]');
      this.next = root.querySelector('[data-vmpc-next]');
      this.addButtons = [...root.querySelectorAll('[data-vmpc-add]')];

      this.bind();
    }

    bind() {
      if (this.viewport) {
        this.prev?.addEventListener('click', () => {
          this.scroll(-1);
        });

        this.next?.addEventListener('click', () => {
          this.scroll(1);
        });
      }

      this.addButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.addToCart(button);
        });
      });
    }

    scroll(direction) {
      if (!this.viewport) return;

      const amount = Math.max(
        250,
        this.viewport.clientWidth * 0.55
      );

      this.viewport.scrollBy({
        left: amount * direction,
        behavior: 'smooth'
      });
    }

    async addToCart(button) {
      if (
        button.disabled ||
        button.classList.contains('is-loading')
      ) {
        return;
      }

      const variantId = Number(button.dataset.variantId);

      if (!variantId) return;

      button.classList.add('is-loading');
      button.disabled = true;

      try {
        const root = window.Shopify?.routes?.root || '/';

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        const result = await response.json();

        button.classList.add('is-success');

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              source: 'velora-mini-carousel',
              result
            }
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );

        setTimeout(() => {
          button.classList.remove('is-success');
        }, 1200);

      } catch (error) {
        console.error('Velora Mini Carousel quick add:', error);
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-vmpc]').forEach((root) => {
      if (root.dataset.vmpcReady === 'true') return;

      root.dataset.vmpcReady = 'true';
      new VeloraMiniCarousel(root);
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
